import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { classifyError, humanMessage } from '@/shared/lib/telemetry'
import s from './WidgetError.module.css'

/**
 * Компактный инлайн-сбой куска экрана — не «упасть» целиком (для этого есть `DeathScreen`),
 * а показать, что не получилось именно здесь, и дать повторить.
 *
 * Изначально жил в `widgets/death-screen` (Task 8, рядом с `DeathScreen`) — перенесён в
 * `shared/ui` в Task 16: у компонента нет ничего «виджетного» (`{ error, retry }`, никакого
 * знания о макете конкретного экрана), а поповерам шапки (`features/company-switch`,
 * `features/notifications-read`) он нужен для показа частного сбоя одного поповера. Слой
 * `features` не может импортировать из `widgets` — FSD и steiger это запрещают («Forbidden
 * import from higher layer "widgets"», проверено живым прогоном `npm run lint`), а генерическому
 * UI-примитиву без доменной логики место в `shared` в любом случае вернее, чем в конкретном
 * виджете. Старый путь `@/widgets/death-screen` продолжает работать — реэкспортом.
 */
export function WidgetError({ error, retry }: { error: unknown; retry: () => void }) {
  const { title } = humanMessage(classifyError(error))
  return (
    <div className={s.root} role="alert">
      <Icon name="alert" size={16} strokeWidth={1.9} className={s.icon} />
      <span className={s.title}>{title}</span>
      <Button variant="secondary" size="sm" onClick={retry}>
        Повторить
      </Button>
    </div>
  )
}
